import { defineStore } from 'pinia'
import { ref } from 'vue'
import { Domain, DomainDetails } from '@/types'
import { useNotifyStore } from '@/stores/notifications'
import { uuid } from '@/composables'
import { z } from 'zod'

export const useDomainsStore = defineStore('domains', () => {
  const domains = ref<Domain[]>([])
  const customDomains = ref<any[]>([])
  const domainDetails = ref<DomainDetails>({} as DomainDetails)

  function setDomains(payload: Domain[]) {
    const validate = z.array(Domain).safeParse(payload)
    if (!validate.success) {
      const notifyStore = useNotifyStore()
      notifyStore.createNotify({
        id: uuid('v4'),
        alertType: 'error',
        title: 'Error',
        message: 'Payload needs to be an array of Domain'
      })
      return
    }
    domains.value = payload
  }

  function setCustomDomains<T>(payload: T) {
    customDomains.value = payload as any[]
  }

  function setDomainDetails(payload: DomainDetails) {
    domainDetails.value = payload
  }

  function getDomains(): Domain[] {
    return domains.value
  }

  function getCustomDomains() {
    return customDomains.value
  }

  function getDomainDetails(): DomainDetails {
    return domainDetails.value
  }

  return {
    domains,
    customDomains,
    domainDetails,
    getDomains,
    setDomains,
    getCustomDomains,
    setCustomDomains,
    getDomainDetails,
    setDomainDetails
  }
})
